import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Banner } from '@hotjar/hotsauce';

export const AutogeneratedRecordingBanner = (): JSX.Element | null => {
  const [visible, setVisible] = useState(true);
  const { t } = useTranslation();

  return visible ? (
    <Banner isDismissible kind="warning" onDismiss={() => setVisible(false)}>
      {t('activation:autogenerated-recording.disclaimer')}
    </Banner>
  ) : null;
};
